module.exports = __webpack_public_path__ + "img/c5.c4d6bf81.png";